export const NOOP = 'NOOP'

export const LOGOUT = 'LOGOUT'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_CHALLENGE = 'LOGIN_CHALLENGE'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const TOKEN_REFRESH_REQUEST = 'TOKEN_REFRESH_REQUEST'
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS'
export const TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE'

export const ADD_RETURN_TO = 'ADD_RETURN_TO'
export const CLEAR_RETURN_TO = 'CLEAR_RETURN_TO'

export const MARK_UPDATE_AVAILABLE = 'MARK_UPDATE_AVAILABLE'

export const AUTO_REDIRECT = 'AUTO_REDIRECT'
export const DEPRECATED_CHANGE_PATH = 'DEPRECATED_CHANGE_PATH'
export const SAVE_RETURN_PATH = 'SAVE_RETURN_PATH'
export const CLEAR_RETURN_PATH = 'CLEAR_RETURN_PATH'
export const UPDATE_CURRENT_USER_WITH_MAILBOXES =
  'UPDATE_CURRENT_USER_WITH_MAILBOXES'
export const UPDATE_APP_DATA = 'UPDATE_APP_DATA'
export const UPDATE_REPORT_SETTINGS = 'UPDATE_REPORT_SETTINGS'
export const ACCOUNT_PREFS_CHANGED = 'ACCOUNT_PREFS_CHANGED'
export const UPDATE_APP_DEVICE_TYPE = 'UPDATE_APP_DEVICE_TYPE'
export const UPDATE_CURRENT_MAILBOX = 'UPDATE_CURRENT_MAILBOX'
export const FETCHED_INBOX_DATA = 'FETCHED_INBOX_DATA'
export const BOOTSTRAP_APP_DATA = 'BOOTSTRAP_APP_DATA'
export const BOOTSTRAP_APP_DATA_STARTED = 'BOOTSTRAP_APP_DATA_STARTED'
export const BOOTSTRAP_APP_DATA_SUCCESS = 'BOOTSTRAP_APP_DATA_SUCCESS'
export const BOOTSTRAP_APP_DATA_FAILED = 'BOOTSTRAP_APP_DATA_FAILED'

export const REMOVE_MAILBOX_LOCALLY = 'REMOVE_MAILBOX_LOCALLY'
export const CREATE_MAILBOX_REQUEST = 'CREATE_MAILBOX_REQUEST'
export const CREATE_MAILBOX_SUCCESS = 'CREATE_MAILBOX_SUCCESS'
export const CREATE_MAILBOX_FAILURE = 'CREATE_MAILBOX_FAILURE'
export const CONVERT_MAILBOX_TO_DEMO_REQUEST = 'CONVERT_MAILBOX_TO_DEMO_REQUEST'
export const CONVERT_MAILBOX_TO_DEMO_SUCCESS = 'CONVERT_MAILBOX_TO_DEMO_SUCCESS'
export const CONVERT_MAILBOX_TO_DEMO_FAILURE = 'CONVERT_MAILBOX_TO_DEMO_FAILURE'
export const REMEMBER_PREVIOUS_MAILBOX = 'REMEMBER_PREVIOUS_MAILBOX'

export const INIT_FOLDER = 'INIT_FOLDER'

export const TICKET_MATCH_START = 'TICKET_MATCH_START'
export const TICKET_MATCHES_SEARCH = 'TICKET_MATCHES_SEARCH'
export const TICKET_MATCHES_FOLDER = 'TICKET_MATCHES_FOLDER'
export const TICKET_MATCH_ERROR = 'TICKET_MATCH_ERROR'

export const SET_CURRENT_TICKET_LIST = 'SET_CURRENT_TICKET_LIST'

export const UPDATE_FIRST_MAILBOX = 'UPDATE_FIRST_MAILBOX'

export const UPDATE_LABELS = 'UPDATE_LABELS'

export const LABELINGS_SAVED = 'LABELINGS_SAVED'
export const UPDATE_LABELING_REQUEST = 'UPDATE_LABELING_REQUEST'
export const UPDATE_LABELING_SUCCESS = 'UPDATE_LABELING_SUCCESS'
export const UPDATE_LABELING_FAIL = 'UPDATE_LABELING_FAIL'

export const BULK_UPDATE_LABELING_REQUEST = 'BULK_UPDATE_LABELING_REQUEST'
export const BULK_UPDATE_LABELING_SUCCESS = 'BULK_UPDATE_LABELING_SUCCESS'
export const BULK_UPDATE_LABELING_FAIL = 'BULK_UPDATE_LABELING_FAIL'

export const BEGIN_EDIT_LABEL = 'BEGIN_EDIT_LABEL'
export const CANCEL_EDIT_LABEL = 'CANCEL_EDIT_LABEL'
export const CREATE_LABEL_REQUEST = 'CREATE_LABEL_REQUEST'
export const CREATE_LABEL_SUCCESS = 'CREATE_LABEL_SUCCESS'
export const CREATE_LABEL_FAIL = 'CREATE_LABEL_FAIL'
export const BEGIN_DELETE_LABEL = 'BEGIN_DELETE_LABEL'
export const CANCEL_DELETE_LABEL = 'CANCEL_DELETE_LABEL'
export const DELETE_LABEL_REQUEST = 'DELETE_LABEL_REQUEST'
export const DELETE_LABEL_SUCCESS = 'DELETE_LABEL_SUCCESS'
export const DELETE_LABEL_FAIL = 'DELETE_LABEL_FAIL'

export const UPDATE_LABEL_REQUEST = 'UPDATE_LABEL_REQUEST'
export const UPDATE_LABEL_SUCCESS = 'UPDATE_LABEL_SUCCESS'
export const UPDATE_LABEL_FAIL = 'UPDATE_LABEL_FAIL'

export const MANAGE_LABELS_BEGIN = 'MANAGE_LABELS_BEGIN'
export const MANAGE_LABELS_END = 'MANAGE_LABELS_END'

export const UPDATE_ACCESS_LIST = 'UPDATE_ACCESS_LIST'
export const REMOVE_ACCESS_LIST = 'REMOVE_ACCESS_LIST'
export const UPDATE_ACTIVE_LABEL_INDEX = 'UPDATE_ACTIVE_LABEL_INDEX'

export const FETCH_LABELS_BY_NAME_REQUEST = 'FETCH_LABELS_BY_NAME_REQUEST'
export const FETCH_LABELS_BY_NAME_SUCCESS = 'FETCH_LABELS_BY_NAME_SUCCESS'
export const FETCH_LABELS_BY_NAME_FAIL = 'FETCH_LABELS_BY_NAME_FAIL'

export const FETCH_FOLDER_WITH_TICKETS_REQUEST =
  'FETCH_FOLDER_WITH_TICKETS_REQUEST'
export const FETCH_FOLDER_WITH_TICKETS_SUCCESS =
  'FETCH_FOLDER_WITH_TICKETS_SUCCESS'
export const FETCH_FOLDER_WITH_TICKETS_FAIL = 'FETCH_FOLDER_WITH_TICKETS_FAIL'
export const FETCH_FOLDER_WITH_TICKETS_COMPLETE =
  'FETCH_FOLDER_WITH_TICKETS_COMPLETE'

export const FETCH_FOLDER_COUNTS_REQUEST = 'FETCH_FOLDER_COUNTS_REQUEST'
export const FETCH_FOLDER_COUNTS_SUCCESS = 'FETCH_FOLDER_COUNTS_SUCCESS'
export const FETCH_FOLDER_COUNTS_FAIL = 'FETCH_FOLDER_COUNTS_FAIL'
export const FETCH_FOLDER_COUNTS_COMPLETE = 'FETCH_FOLDER_COUNTS_COMPLETE'

export const FETCH_TICKET_AGGREGATION_COUNTS_REQUEST =
  'FETCH_TICKET_AGGREGATION_COUNTS_REQUEST'
export const FETCH_TICKET_AGGREGATION_COUNTS_SUCCESS =
  'FETCH_TICKET_AGGREGATION_COUNTS_SUCCESS'
export const FETCH_TICKET_AGGREGATION_COUNTS_FAIL =
  'FETCH_TICKET_AGGREGATION_COUNTS_FAIL'

export const CURRENT_FOLDER_WITH_TICKETS_NEXT_PAGE_REQUEST =
  'CURRENT_FOLDER_WITH_TICKETS_NEXT_PAGE_REQUEST'
export const CURRENT_FOLDER_WITH_TICKETS_NEXT_PAGE_SUCCESS =
  'CURRENT_FOLDER_WITH_TICKETS_NEXT_PAGE_SUCCESS'
export const CURRENT_FOLDER_WITH_TICKETS_NEXT_PAGE_FAIL =
  'CURRENT_FOLDER_WITH_TICKETS_NEXT_PAGE_FAIL'
export const CURRENT_FOLDER_WITH_TICKETS_NEXT_PAGE_COMPLETE =
  'CURRENT_FOLDER_WITH_TICKETS_NEXT_PAGE_COMPLETE'

export const ADD_CREATED_TICKET = 'ADD_CREATED_TICKET'
export const LIST_SCROLL_TOP_CHANGED = 'LIST_SCROLL_TOP_CHANGED'

export const KEY_PRESSED_CHANGE = 'KEY_PRESSED_CHANGE'
export const MARK_BULK_SELECTION_MODE = 'MARK_BULK_SELECTION_MODE'
export const UNMARK_BULK_SELECTION_MODE = 'UNMARK_BULK_SELECTION_MODE'
export const TOGGLE_TICKET_SELECTION = 'TOGGLE_TICKET_SELECTION'
export const RANGED_TICKET_SELECTION = 'RANGED_TICKET_SELECTION'

export const SELECT_TICKET = 'SELECT_TICKET'
export const DESELECT_TICKET = 'DESELECT_TICKET'
export const DESELECT_ALL_TICKETS = 'DESELECT_ALL_TICKETS'
export const UPDATE_TICKETS = 'UPDATE_TICKETS'

export const SEARCH_REQUEST = 'SEARCH_REQUEST'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_ERROR = 'SEARCH_ERROR'
export const SEARCH_COMPLETE = 'SEARCH_COMPLETE'

export const SEARCH_BY_TICKET_NUMBER_REQUEST = 'SEARCH_BY_TICKET_NUMBER_REQUEST'
export const SEARCH_BY_TICKET_NUMBER_SUCCESS = 'SEARCH_BY_TICKET_NUMBER_SUCCESS'
export const SEARCH_BY_TICKET_NUMBER_FAIL = 'SEARCH_BY_TICKET_NUMBER_FAIL'

export const MERGE_SEARCH_REQUEST = 'MERGE_SEARCH_REQUEST'
export const MERGE_SEARCH_SUCCESS = 'MERGE_SEARCH_SUCCESS'
export const MERGE_SEARCH_ERROR = 'MERGE_SEARCH_ERROR'

export const SEARCHES_REQUEST = 'SEARCHES_REQUEST'
export const SEARCHES_SUCCESS = 'SEARCHES_SUCCESS'
export const SEARCHES_FAIL = 'SEARCHES_FAIL'

export const SEARCH_RECIPIENT_REQUEST = 'SEARCH_RECIPIENT_REQUEST'
export const SEARCH_RECIPIENT_COMPLETE = 'SEARCH_RECIPIENT_COMPLETE'
export const SEARCH_USER_REQUEST = 'SEARCH_USER_REQUEST'
export const SEARCH_USER_SUCCESS = 'SEARCH_USER_SUCCESS'
export const SEARCH_USER_FAIL = 'SEARCH_USER_FAIL'
export const SEARCH_USER_COMPLETE = 'SEARCH_USER_COMPLETE'
export const SEARCH_CLEAR_TICKET_RESULTS = 'SEARCH_CLEAR_TICKET_RESULTS'

export const MERGEABLE_SEARCH_REQUEST = 'MERGEABLE_SEARCH_REQUEST'
export const MERGEABLE_SEARCH_SUCCESS = 'MERGEABLE_SEARCH_SUCCESS'

export const STORE_LATEST_SEARCH = 'STORE_LATEST_SEARCH'
export const STORE_TICKET_LIST_BEFORE_SEARCH = 'STORE_TICKET_LIST_BEFORE_SEARCH'
export const RENDER_TICKET_LIST_BEFORE_SEARCH =
  'RENDER_TICKET_LIST_BEFORE_SEARCH'

export const CLEAR_USER_SUGGESTION = 'CLEAR_USER_SUGGESTION'

export const UPDATE_CURRENT_TICKET_SEARCH_QUERY =
  'UPDATE_CURRENT_TICKET_SEARCH_QUERY'

export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR'
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR'

export const OPEN_CHANGE_INBOX_MENU = 'OPEN_CHANGE_INBOX_MENU'
export const CLOSE_CHANGE_INBOX_MENU = 'CLOSE_CHANGE_INBOX_MENU'

export const OPEN_MORE_TICKET_OPTIONS_MENU = 'OPEN_MORE_TICKET_OPTIONS_MENU'
export const CLOSE_MORE_TICKET_OPTIONS_MENU = 'CLOSE_MORE_TICKET_OPTIONS_MENU'

export const UPDATE_MODAL_PROPS = 'UPDATE_MODAL_PROPS'

export const UPDATE_LABEL_SEARCH_RESULTS = 'UPDATE_LABEL_SEARCH_RESULTS'
export const SEARCH_LABELS_REQUEST = 'SEARCH_LABELS_REQUEST'
export const CLEAR_LABEL_SEARCH_TERM = 'CLEAR_LABEL_SEARCH_TERM'
export const CLEAR_LABEL_SEARCH_RESULTS = 'CLEAR_LABEL_SEARCH_RESULTS'
export const MAILBOX_LABELS_REQUEST = 'MAILBOX_LABELS_REQUEST'
export const MAILBOX_LABELS_SUCCESS = 'MAILBOX_LABELS_SUCCESS'
export const MAILBOX_LABELS_FAIL = 'MAILBOX_LABELS_FAIL'
export const LABEL_SELECTION_CLICK = 'LABEL_SELECTION_CLICK'

export const STAR_TICKETS_STARTED = 'STAR_TICKETS_STARTED'
export const STAR_TICKETS_SUCCESS = 'STAR_TICKETS_SUCCESS'

export const DELETE_TICKETS = 'DELETE_TICKETS'
export const DELETE_TICKETS_STARTED = 'DELETE_TICKETS_STARTED'
export const DELETE_TICKETS_SUCCESS = 'DELETE_TICKETS_SUCCESS'
export const DELETE_TICKETS_FAIL = 'DELETE_TICKETS_FAIL'

export const TOGGLE_TICKETS_SORTING = 'TOGGLE_TICKETS_SORTING'
export const TOGGLE_SHOW_CC_BCC = 'TOGGLE_SHOW_CC_BCC'
export const SET_TICKETS_CURTAIN_VISIBILITY = 'SET_TICKETS_CURTAIN_VISIBILITY'

export const MARK_FETCHING_STATUS = 'MARK_FETCHING_STATUS'
export const CLEAR_FETCHED_STATUSES = 'CLEAR_FETCHED_STATUSES'
export const CHANGE_NAVIGATION_VISIBILITY = 'CHANGE_NAVIGATION_VISIBILITY'
export const CHANGE_MAILBOX_SWITCHER_VISIBILITY =
  'CHANGE_MAILBOX_SWITCHER_VISIBILITY'
export const TOGGLE_NAV_SECTION = 'TOGGLE_NAV_SECTION'
export const SELECT_TICKETS = 'SELECT_TICKETS'

export const ADD_ACTION = 'ADD_ACTION'
export const ADD_CHANGESET = 'ADD_CHANGESET'
export const ADD_TICKET = 'ADD_TICKET'

export const FETCH_TICKET_REQUEST = 'FETCH_TICKET_REQUEST'
export const FETCH_TICKET_SUCCESS = 'FETCH_TICKET_SUCCESS'
export const FETCH_TICKET_FAIL = 'FETCH_TICKET_FAIL'

export const FETCH_TICKET_ACTIONS_REQUEST = 'FETCH_TICKET_ACTIONS_REQUEST'
export const FETCH_TICKET_ACTIONS_SUCCESS = 'FETCH_TICKET_ACTIONS_SUCCESS'
export const FETCH_TICKET_ACTIONS_FAIL = 'FETCH_TICKET_ACTIONS_FAIL'

export const FETCH_TICKET_LINKED_RESOURCES_FAIL =
  'FETCH_TICKET_LINKED_RESOURCES_FAIL'
export const FETCH_TICKET_LINKED_RESOURCES_REQUEST =
  'FETCH_TICKET_LINKED_RESOURCES_REQUEST'
export const FETCH_TICKET_LINKED_RESOURCES_SUCCESS =
  'FETCH_TICKET_LINKED_RESOURCES_SUCCESS'
export const BULK_FETCH_TICKET_ACTIONS_SUCCESS =
  'BULK_FETCH_TICKET_ACTIONS_SUCCESS'

export const FETCH_CHANGESET_TICKET_ACTIONS_REQUEST =
  'FETCH_CHANGESET_TICKET_ACTIONS_REQUEST'
export const FETCH_CHANGESET_TICKET_ACTIONS_SUCCESS =
  'FETCH_CHANGESET_TICKET_ACTIONS_SUCCESS'
export const FETCH_CHANGESET_TICKET_ACTIONS_FAIL =
  'FETCH_CHANGESET_TICKET_ACTIONS_FAIL'

export const BULK_FETCH_CHANGESET_TICKET_ACTIONS_REQUEST =
  'BULK_FETCH_CHANGESET_TICKET_ACTIONS_REQUEST'
export const BULK_FETCH_CHANGESET_TICKET_ACTIONS_SUCCESS =
  'BULK_FETCH_CHANGESET_TICKET_ACTIONS_SUCCESS'

export const CREATE_CHANGESET_REQUEST = 'CREATE_CHANGESET_REQUEST'
export const CREATE_CHANGESET_SUCCESS = 'CREATE_CHANGESET_SUCCESS'
export const CREATE_CHANGESET_FAIL = 'CREATE_CHANGESET_FAIL'

export const CREATE_BULK_CHANGESET_REQUEST = 'CREATE_BULK_CHANGESET_REQUEST'
export const CREATE_BULK_CHANGESET_SUCCESS = 'CREATE_BULK_CHANGESET_SUCCESS'
export const CREATE_BULK_CHANGESET_FAIL = 'CREATE_BULK_CHANGESET_FAIL'
export const CREATE_BULK_CHANGESET_COMPLETE = 'CREATE_BULK_CHANGESET_COMPLETE'
export const CREATE_TICKET_REQUEST = 'CREATE_TICKET_REQUEST'
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS'
export const CREATE_TICKET_FAIL = 'CREATE_TICKET_FAIL'
export const CREATE_TICKET_COMPLETE = 'CREATE_TICKET_COMPLETE'

export const ASSIGN_TICKET_TO_AGENT = 'ASSIGN_TICKET_TO_AGENT'
export const ASSIGN_TICKETS_TO_AGENT = 'ASSIGN_TICKETS_TO_AGENT'

export const REALTIME_NOTE_UPDATE = 'REALTIME_NOTE_UPDATE'
export const ADD_PAGE_TO_CURRENT_FOLDER = 'ADD_PAGE_TO_CURRENT_FOLDER'
export const UPDATE_RAW_EMAIL = 'UPDATE_RAW_EMAIL'
export const UPDATE_NOTE_FORM_HEIGHT = 'UPDATE_NOTE_FORM_HEIGHT'
export const SET_TICKET_ASSIGNMENT_FILTER = 'SET_TICKET_ASSIGNMENT_FILTER'
export const SET_TICKET_GROUP_ASSIGNMENT_FILTER =
  'SET_TICKET_GROUP_ASSIGNMENT_FILTER'
export const SET_MAILBOX_CHANGE_FILTER = 'SET_MAILBOX_CHANGE_FILTER'

export const SNOOZE_TICKETS_REQUEST = 'SNOOZE_TICKETS_REQUEST'
export const SNOOZE_TICKETS_SUCCESS = 'SNOOZE_TICKETS_SUCCESS'
export const SNOOZE_TICKETS_COMPLETE = 'SNOOZE_TICKETS_COMPLETE'
export const UPDATE_SELECTED_SNOOZE_STATE = 'UPDATE_SELECTED_SNOOZE_STATE'
export const SAVE_LAST_SNOOZED_DATE = 'SAVE_LAST_SNOOZED_DATE'

export const UPDATE_REALTIME_STATUS = 'UPDATE_REALTIME_STATUS'
export const UPDATE_TICKET_DIRTY_STATUS = 'UPDATE_TICKET_DIRTY_STATUS'

export const TICKET_TITLE_EDITING_START = 'TICKET_TITLE_EDITING_START'
export const TICKET_TITLE_EDITING_STOP = 'TICKET_TITLE_EDITING_STOP'
export const TICKET_TITLE_UPDATE_REQUEST = 'TICKET_TITLE_UPDATE_REQUEST'
export const TICKET_TITLE_UPDATE_COMPLETE = 'TICKET_TITLE_UPDATE_COMPLETE'
export const TICKET_TITLE_DRAFT_CHANGED = 'TICKET_TITLE_DRAFT_CHANGED'

export const ATTACHMENT_UPLOAD_STARTED = 'ATTACHMENT_UPLOAD_STARTED'
export const ATTACHMENT_UPLOAD_PROGRESSED = 'ATTACHMENT_UPLOAD_PROGRESSED'
export const ATTACHMENT_UPLOAD_FINISHED = 'ATTACHMENT_UPLOAD_FINISHED'
export const ATTACHMENT_UPLOAD_FAILED = 'ATTACHMENT_UPLOAD_FAILED'
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT'

export const UNDO_SEND_TIMER_START = 'UNDO_SEND_TIMER_START'
export const UNDO_SEND_TIMER_END = 'UNDO_SEND_TIMER_END'
export const UNDO_SEND_TIMER_TICK = 'UNDO_SEND_TIMER_TICK'
export const UNDO_SEND_REQUEST = 'UNDO_SEND_REQUEST'
export const UNDO_SEND_SUCCESS = 'UNDO_SEND_SUCCESS'
export const UNDO_SEND_FAIL = 'UNDO_SEND_FAIL'
export const UNDO_SEND = 'UNDO_SEND'
export const UNDO_SEND_COMPLETE = 'UNDO_SEND_COMPLETE'

// Modals
export const GROUP_DRILL_DOWN = 'GROUP_DRILL_DOWN'

export const QUEUE_EDITOR_TOOLBAR_MESSAGE = 'QUEUE_EDITOR_TOOLBAR_MESSAGE'
export const PROCESS_NEXT_EDITOR_TOOLBAR_MESSAGE =
  'PROCESS_NEXT_EDITOR_TOOLBAR_MESSAGE'
export const CLEAR_EDITOR_TOOLBAR_MESSAGES = 'CLEAR_EDITOR_TOOLBAR_MESSAGES'

export const SET_JUST_CLOSED_KEYBOARD = 'SET_JUST_CLOSED_KEYBOARD'

export const UPDATE_INACCESSIBLE_MAILBOXES = 'UPDATE_INACCESSIBLE_MAILBOXES'

export const SWAP_MERGE_DIRECTION = 'SWAP_MERGE_DIRECTION'
export const TICKETS_SELECTED_FOR_MERGE = 'TICKETS_SELECTED_FOR_MERGE'
export const CANCEL_MERGE = 'CANCEL_MERGE'

export const MERGE_TICKETS_REQUEST = 'MERGE_TICKETS_REQUEST'
export const MERGE_TICKETS_SUCCESS = 'MERGE_TICKETS_SUCCESS'
export const MERGE_TICKETS_COMPLETE = 'MERGE_TICKETS_COMPLETE'
export const MERGE_TICKETS_FAIL = 'MERGE_TICKETS_FAIL'

export const FETCH_OPTIMISTIC_MERGE_TICKETS_REQUEST =
  'FETCH_OPTIMISTIC_MERGE_TICKETS_REQUEST'
export const FETCH_OPTIMISTIC_MERGE_TICKETS_SUCCESS =
  'FETCH_OPTIMISTIC_MERGE_TICKETS_SUCCESS'

export const FETCH_TOP_LABELS_REQUEST = 'FETCH_TOP_LABELS_REQUEST'
export const FETCH_TOP_LABELS_SUCCESS = 'FETCH_TOP_LABELS_SUCCESS'

export const FETCH_TICKET_SNIPPETS_REQUEST = 'FETCH_TICKET_SNIPPETS_REQUEST'
export const FETCH_TICKET_SNIPPETS_SUCCESS = 'FETCH_TICKET_SNIPPETS_SUCCESS'
export const FETCH_TICKET_SNIPPETS_FAIL = 'FETCH_TICKET_SNIPPETS_FAIL'
export const UPDATE_MERGE_SNIPPETS_VISIBILITY =
  'UPDATE_MERGE_SNIPPETS_VISIBILITY'

export const WEB_PUSH_SUBSCRIPTION_CREATE = 'WEB_PUSH_SUBSCRIPTION_CREATE'
export const WEB_PUSH_SUBSCRIPTION_CREATED = 'WEB_PUSH_SUBSCRIPTION_CREATED'
export const WEB_PUSH_SUBSCRIPTION_CREATE_FAIL =
  'WEB_PUSH_SUBSCRIPTION_CREATE_FAIL'

export const WEB_PUSH_SUBSCRIPTION_LOAD = 'WEB_PUSH_SUBSCRIPTION_LOAD'
export const WEB_PUSH_SUBSCRIPTION_LOADED = 'WEB_PUSH_SUBSCRIPTION_LOADED'
export const WEB_PUSH_SUBSCRIPTION_LOAD_FAIL = 'WEB_PUSH_SUBSCRIPTION_LOAD_FAIL'

export const FETCH_WEB_PUSH_SUBSCRIPTIONS_REQUEST =
  'FETCH_WEB_PUSH_SUBSCRIPTIONS_REQUEST'
export const FETCH_WEB_PUSH_SUBSCRIPTIONS_SUCCESS =
  'FETCH_WEB_PUSH_SUBSCRIPTIONS_SUCCESS'
export const FETCH_WEB_PUSH_SUBSCRIPTIONS_FAIL =
  'FETCH_WEB_PUSH_SUBSCRIPTIONS_FAIL'

export const WEB_PUSH_SUBSCRIBE = 'WEB_PUSH_SUBSCRIBE'
export const WEB_PUSH_SUBSCRIBE_COMPLETE = 'WEB_PUSH_SUBSCRIBE_COMPLETE'
export const WEB_PUSH_SUBSCRIBE_FAIL = 'WEB_PUSH_SUBSCRIBE_FAIL'

export const SAVE_WEB_PUSH_SUBSCRIPTION_REQUEST =
  'SAVE_WEB_PUSH_SUBSCRIPTION_REQUEST'
export const SAVE_WEB_PUSH_SUBSCRIPTION_SUCCESS =
  'SAVE_WEB_PUSH_SUBSCRIPTION_SUCCESS'
export const SAVE_WEB_PUSH_SUBSCRIPTION_FAIL = 'SAVE_WEB_PUSH_SUBSCRIPTION_FAIL'

export const WEB_PUSH_UNSUBSCRIBE = 'WEB_PUSH_UNSUBSCRIBE'
export const WEB_PUSH_UNSUBSCRIBE_COMPLETE = 'WEB_PUSH_UNSUBSCRIBE_COMPLETE'
export const WEB_PUSH_UNSUBSCRIBE_FAIL = 'WEB_PUSH_UNSUBSCRIBE_FAIL'

export const DELETE_WEB_PUSH_SUBSCRIPTION_REQUEST =
  'DELETE_WEB_PUSH_SUBSCRIPTION_REQUEST'
export const DELETE_WEB_PUSH_SUBSCRIPTION_SUCCESS =
  'DELETE_WEB_PUSH_SUBSCRIPTION_SUCCESS'
export const DELETE_WEB_PUSH_SUBSCRIPTION_FAIL =
  'DELETE_WEB_PUSH_SUBSCRIPTION_FAIL'

export const WEB_PUSH_RESUBSCRIBE = 'WEB_PUSH_RESUBSCRIBE'

export const UPDATE_AGENT = 'UPDATE_AGENT'
export const REMOVE_AGENT = 'REMOVE_AGENT'

export const FETCH_EMBEDDABLE_CARD_CONTENT_FETCHING =
  'FETCH_EMBEDDABLE_CARD_CONTENT_FETCHING'
export const FETCH_EMBEDDABLE_CARD_CONTENT_RECEIVED =
  'FETCH_EMBEDDABLE_CARD_CONTENT_RECEIVED'
export const FETCH_EMBEDDABLE_CARD_CONTENT_ERRORED =
  'FETCH_EMBEDDABLE_CARD_CONTENT_ERRORED'
export const TRIGGER_EMBEDDABLE_CARD_ERRORED = 'TRIGGER_EMBEDDABLE_CARD_ERRORED'
export const TRIGGER_EMBEDDABLE_CARD_SUCCESS = 'TRIGGER_EMBEDDABLE_CARD_SUCCESS'

export const UPDATE_CARD_LOADING = 'UPDATE_CARD_LOADING'
export const UPDATE_CARD_COLLAPSED = 'UPDATE_CARD_COLLAPSED'
export const UPDATE_CARD_HIDDEN = 'UPDATE_CARD_HIDDEN'
export const UPDATE_CARD_TAB_TITLE = 'UPDATE_CARD_TAB_TITLE'
export const ACTIVATE_CARD_TAB = 'ACTIVATE_CARD_TAB'
export const CARD_ON_CONTEXT_CHANGE_REGISTERED =
  'CARD_ON_CONTEXT_CHANGE_REGISTERED'

export const FETCH_TOP_ASSIGNMENTS_REQUEST = 'FETCH_TOP_ASSIGNMENTS_REQUEST'
export const FETCH_TOP_ASSIGNMENTS_SUCCESS = 'FETCH_TOP_ASSIGNMENTS_SUCCESS'
export const FETCH_TOP_ASSIGNMENTS_FAIL = 'FETCH_TOP_ASSIGNMENTS_FAIL'

export const TOGGLE_SEARCH_MODIFIER = 'TOGGLE_SEARCH_MODIFIER'

export const FETCH_AGENTS_REQUEST = 'FETCH_AGENTS_REQUEST'
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS'
export const FETCH_AGENTS_FAIL = 'FETCH_AGENTS_FAIL'

export const PIN_SEARCH_REQUEST = 'PIN_SEARCH_REQUEST'
export const PIN_SEARCH_SUCCESS = 'PIN_SEARCH_SUCCESS'
export const PIN_SEARCH_FAILURE = 'PIN_SEARCH_FAILURE'

export const UNPIN_SEARCH_REQUEST = 'UNPIN_SEARCH_REQUEST'
export const UNPIN_SEARCH_SUCCESS = 'UNPIN_SEARCH_SUCCESS'
export const UNPIN_SEARCH_FAILURE = 'UNPIN_SEARCH_FAILURE'

export const UPDATE_AGENT_MENTION = 'UPDATE_AGENT_MENTION'
export const UPDATE_SELECTED_MENTION_SELECTOR_AGENT_ID =
  'UPDATE_SELECTED_MENTION_SELECTOR_AGENT_ID'
export const UPDATE_SUPPRESS_MENTION_SELECTOR =
  'UPDATE_SUPPRESS_MENTION_SELECTOR'

export const REMOVE_GHOST_TICKET = 'REMOVE_GHOST_TICKET'

export const LIGHTBOX_NEXT = 'LIGHTBOX_NEXT'
export const LIGHTBOX_PREVIOUS = 'LIGHTBOX_PREVIOUS'

export const EDIT_NOTE = 'EDIT_NOTE'
export const BLUR_EDIT_NOTE = 'BLUR_EDIT_NOTE'
export const CANCEL_EDIT_NOTE = 'CANCEL_EDIT_NOTE'
export const UPDATE_EDITING_NOTE = 'UPDATE_EDITING_NOTE'
export const UPDATE_NOTE_REQUEST = 'UPDATE_NOTE_REQUEST'
export const UPDATE_NOTE_SUCCESS = 'UPDATE_NOTE_SUCCESS'
export const UPDATE_NOTE_FAILURE = 'UPDATE_NOTE_FAILURE'

export const SHOW_REPLY_FORM_ROW = 'SHOW_REPLY_FORM_ROW'
export const COMPLETE_PENDING_AUTOFOCUS_REPLY_FORM_ROW =
  'COMPLETE_PENDING_AUTOFOCUS_REPLY_FORM_ROW'

export const TOGGLE_LIST_SEARCH_BOX_STATUS = 'TOGGLE_LIST_SEARCH_BOX_STATUS'

export const MAILBOX_SEARCH_INPUT = 'MAILBOX_SEARCH_INPUT'

export const LOG_NEW_CONVERSATION = 'LOG_NEW_CONVERSATION'
export const NEW_CONVERSATION_LOGGED = 'NEW_CONVERSATION_LOGGED'

export const TOGGLE_LEFT_SIDEBAR = 'TOGGLE_LEFT_SIDEBAR'
export const TOGGLE_RIGHT_SIDEBAR = 'TOGGLE_RIGHT_SIDEBAR'
export const SET_LEFT_SIDEBAR_OPEN_STATE = 'SET_LEFT_SIDEBAR_OPEN_STATE'

export const INTEGRATIONS_CLEAN_FORM_VALUES = 'INTEGRATIONS_CLEAN_FORM_VALUES'

export const INTEGRATIONS_UPDATE_FORM_VALUE = 'INTEGRATIONS_UPDATE_FORM_VALUE'
export const INTEGRATIONS_INTEGRATION_SELECTED =
  'INTEGRATIONS_INTEGRATION_SELECTED'
export const INTEGRATIONS_METHOD_CHANGED = 'INTEGRATIONS_METHOD_CHANGED'

export const INTEGRATION_FETCH_GITHUB_REPOS_REQUEST =
  'INTEGRATION_FETCH_GITHUB_REPOS_REQUEST'
export const INTEGRATION_FETCH_GITHUB_REPOS_SUCCESS =
  'INTEGRATION_FETCH_GITHUB_REPOS_SUCCESS'
export const INTEGRATION_FETCH_GITHUB_REPOS_FAILURE =
  'INTEGRATION_FETCH_GITHUB_REPOS_FAILURE'

export const INTEGRATION_FETCH_GITHUB_REPO_DETAILS_REQUEST =
  'INTEGRATION_FETCH_GITHUB_REPO_DETAILS_REQUEST'
export const INTEGRATION_FETCH_GITHUB_REPO_DETAILS_SUCCESS =
  'INTEGRATION_FETCH_GITHUB_REPO_DETAILS_SUCCESS'
export const INTEGRATION_FETCH_GITHUB_REPO_DETAILS_FAILURE =
  'INTEGRATION_FETCH_GITHUB_REPO_DETAILS_FAILURE'

export const INTEGRATION_FETCH_GITHUB_ISSUES_REQUEST =
  'INTEGRATION_FETCH_GITHUB_ISSUES_REQUEST'
export const INTEGRATION_FETCH_GITHUB_ISSUES_SUCCESS =
  'INTEGRATION_FETCH_GITHUB_ISSUES_SUCCESS'
export const INTEGRATION_FETCH_GITHUB_ISSUES_FAILURE =
  'INTEGRATION_FETCH_GITHUB_ISSUES_FAILURE'

export const INTEGRATION_CREATE_GITHUB_ISSUE_REQUEST =
  'INTEGRATION_CREATE_GITHUB_ISSUE_REQUEST'
export const INTEGRATION_CREATE_GITHUB_ISSUE_SUCCESS =
  'INTEGRATION_CREATE_GITHUB_ISSUE_SUCCESS'
export const INTEGRATION_CREATE_GITHUB_ISSUE_FAILURE =
  'INTEGRATION_CREATE_GITHUB_ISSUE_FAILURE'

export const INTEGRATIONS_ATTACH_TO_TICKET_REQUEST =
  'INTEGRATIONS_ATTACH_TO_TICKET_REQUEST'
export const INTEGRATIONS_ATTACH_TO_TICKET_SUCCESS =
  'INTEGRATIONS_ATTACH_TO_TICKET_SUCCESS'
export const INTEGRATIONS_ATTACH_TO_TICKET_FAILURE =
  'INTEGRATIONS_ATTACH_TO_TICKET_FAILURE'

export const INTEGRATION_SET_NEXT_STEP_DEPENDENCY_FIELDS =
  'INTEGRATION_SET_NEXT_STEP_DEPENDENCY_FIELDS'

export const SIDEBARCARD_FETCH_DATA_REQUEST = 'SIDEBARCARD_FETCH_DATA_REQUEST'
export const SIDEBARCARD_FETCH_DATA_SUCCESS = 'SIDEBARCARD_FETCH_DATA_SUCCESS'
export const SIDEBARCARD_FETCH_DATA_FAILURE = 'SIDEBARCARD_FETCH_DATA_FAILURE'
export const SIDEBARCARD_CHANGE_OPEN_STATE = 'SIDEBARCARD_CHANGE_OPEN_STATE'

export const INTEGRATION_FORM_SET_REQUIRED_FIELDS =
  'INTEGRATION_FORM_SET_REQUIRED_FIELDS'
export const INTEGRATION_FORM_SHOW_VALIDATION_ERRORS =
  'INTEGRATION_FORM_SHOW_VALIDATION_ERRORS'
export const EMAIL_MARKETING_SUBSCRIBE_SUCCESS =
  'EMAIL_MARKETING_SUBSCRIBE_SUCCESS'
export const EMAIL_MARKETING_SUBSCRIBE_FAILURE =
  'EMAIL_MARKETING_SUBSCRIBE_FAILURE'
export const EMAIL_MARKETING_SUBSCRIBE_REQUEST =
  'EMAIL_MARKETING_SUBSCRIBE_REQUEST'

export const EMAIL_MARKETING_UNSUBSCRIBE_SUCCESS =
  'EMAIL_MARKETING_UNSUBSCRIBE_SUCCESS'
export const EMAIL_MARKETING_UNSUBSCRIBE_FAILURE =
  'EMAIL_MARKETING_UNSUBSCRIBE_FAILURE'
export const EMAIL_MARKETING_UNSUBSCRIBE_REQUEST =
  'EMAIL_MARKETING_UNSUBSCRIBE_REQUEST'

export const EMAIL_MARKETING_GET_INTEGRATION_STATE_REQUEST =
  'EMAIL_MARKETING_GET_INTEGRATION_STATE_REQUEST'
export const EMAIL_MARKETING_GET_INTEGRATION_STATE_SUCCESS =
  'EMAIL_MARKETING_GET_INTEGRATION_STATE_SUCCESS'
export const EMAIL_MARKETING_GET_INTEGRATION_STATE_FAILURE =
  'EMAIL_MARKETING_GET_INTEGRATION_STATE_FAILURE'

export const EMAIL_MARKETING_FETCH_INTEGRATIONS_REQUEST =
  'EMAIL_MARKETING_FETCH_INTEGRATIONS_REQUEST'
export const EMAIL_MARKETING_FETCH_INTEGRATIONS_SUCCESS =
  'EMAIL_MARKETING_FETCH_INTEGRATIONS_SUCCESS'
export const EMAIL_MARKETING_FETCH_INTEGRATIONS_FAILURE =
  'EMAIL_MARKETING_GET_INTEGRATION_STATE_FAILURE'

export const CREATE_INVITATION_REQUEST = 'CREATE_INVITATION_REQUEST'
export const CREATE_INVITATION_SUCCESS = 'CREATE_INVITATION_SUCCESS'
export const CREATE_INVITATION_FAILURE = 'CREATE_INVITATION_FAILURE'

export const ACCEPT_INVITATION_REQUEST = 'ACCEPT_INVITATION_REQUEST'
export const ACCEPT_INVITATION_SUCCESS = 'ACCEPT_INVITATION_SUCCESS'
export const ACCEPT_INVITATION_FAILURE = 'ACCEPT_INVITATION_FAILURE'

export const GET_INVITATION_REQUEST = 'GET_INVITATION_REQUEST'
export const GET_INVITATION_SUCCESS = 'GET_INVITATION_SUCCESS'
export const GET_INVITATION_FAILURE = 'GET_INVITATION_FAILURE'

export const SEARCH_REFRESH_START = 'SEARCH_REFRESH_START'
export const SEARCH_REFRESH_FINISH = 'SEARCH_REFRESH_FINISH'
export const SEARCH_CLEAR_ALL = 'SEARCH_CLEAR_ALL'

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL'

export const FORGOT_SUBDOMAIN_REQUEST = 'FORGOT_SUBDOMAIN_REQUEST'
export const FORGOT_SUBDOMAIN_SUCCESS = 'FORGOT_SUBDOMAIN_SUCCESS'
export const FORGOT_SUBDOMAIN_FAIL = 'FORGOT_SUBDOMAIN_FAIL'

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL'

export const LOAD_RESET_PASSWORD_REQUEST = 'LOAD_RESET_PASSWORD_REQUEST'
export const LOAD_RESET_PASSWORD_SUCCESS = 'LOAD_RESET_PASSWORD_SUCCESS'
export const LOAD_RESET_PASSWORD_FAIL = 'LOAD_RESET_PASSWORD_FAIL'

export const HIDE_LAUNCH_BAR = 'HIDE_LAUNCH_BAR'

export const CHANGE_REPLY_FORM_FOCUS = 'CHANGE_REPLY_FORM_FOCUS'

export const UPDATE_LAST_TICKET_LIST_SCROLLER_SCROLL_STATE =
  'UPDATE_LAST_TICKET_LIST_SCROLLER_SCROLL_STATE'

export const TOGGLE_PIN_EXPANDED_REPLY_FORM_HEADER =
  'TOGGLE_PIN_EXPANDED_REPLY_FORM_HEADER'

export const TICKET_ID_SEARCH_REDIRECT = 'TICKET_ID_SEARCH_REDIRECT'

export const MARK_SEARCH_AS_COMPLETE = 'MARK_SEARCH_AS_COMPLETE'

export const TOGGLE_PRINT_MODE = 'TOGGLE_PRINT_MODE'

export const UPDATE_ACCOUNT = 'account/UPDATE_ACCOUNT'
export const UPDATE_ACCOUNT_STARTED = 'account/UPDATE_ACCOUNT_STARTED'
export const UPDATE_ACCOUNT_SUCCESS = 'account/UPDATE_ACCOUNT_SUCCESS'
export const UPDATE_ACCOUNT_FAILED = 'account/UPDATE_ACCOUNT_FAILED'
